import { useEffect, useState } from 'react'
import { buildQueryParams } from '#app/shared/lib/objects.js'

export interface PaymentIntentData {
  id: string | null
  secret: string | null
  error: any | null
}

type Props = {
  amount: number // in eur
  purchaseDescription: string
}
export default function usePaymentIntentAPIs({
  amount,
  purchaseDescription,
}: Props) {
  const [paymentIntent, setPaymentIntent] = useState<PaymentIntentData>({
    id: null,
    secret: null,
    error: null,
  })

  useEffect(() => {
    const createPaymentIntent = async () => {
      let queryParams = buildQueryParams({
        amount,
        method: 'card',
        purchaseDescription,
      })
      const response = await fetch(
        '/api/payment/intent/create?' + queryParams.toString(),
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )

      const data: any = await response.json()

      if (!data.error) {
        setPaymentIntent({
          id: data.id,
          secret: data.client_secret,
          error: null,
        })
        return
      }

      setPaymentIntent({
        ...paymentIntent,
        error: data.error,
      })
    }
    void createPaymentIntent() // void to avoid have to put await
  }, [])

  return {
    paymentIntent,
  }
}
